export default __webpack_public_path__ + "static/media/51.4e623d21.jpeg";